module.exports = __webpack_public_path__ + "static/media/promotion-icon.f2c00c76.svg";